import React, { useEffect, useState } from "react";
import MoodLineChart from "../../components/MoodLineChart";
import { useB2BContext } from "../../context/ContextB2B";
import moment from "moment";
import { authSVC } from "../../services";
import "./TeamMoodOverview.scss";

export default function TeamMoodOverview() {
  const { getUserByID } = useB2BContext();
  const [yearlyMoodOverview, setYearlyMoodOverview] = useState<any[]>([]);
  const isDemo = JSON.parse(localStorage.getItem("Demo_check") ?? "false");
  useEffect(() => {
    const year: any = moment().format("yyyy");
    if (getUserByID) {
      authSVC
        .yearlyMoodOverview({ department: "", year: Number(year),company: getUserByID?.company })
        .then((res) => {
         const staticmood = {
  Avg: [
    { day: "Jan", avg: 1.1 },
    { day: "Feb", avg: 1.3 },
    { day: "Mar", avg: 1.5 },
    { day: "Apr", avg: 1.7 },
    { day: "May", avg: 2 },
    { day: "Jun", avg: 2.4 },
    { day: "Jul", avg: null },
    { day: "Aug", avg: null },
    { day: "Sep", avg: null },
    { day: "Oct", avg: null},
    { day: "Nov", avg: null},
    { day: "Dec", avg: null },
  ],
  color: "#b21e49",
};

setYearlyMoodOverview(isDemo ? staticmood : res?.data);
          setYearlyMoodOverview(isDemo ? staticmood : res?.data );
          console.log(res?.data.Avg, "setYearlyMoodOverview");
        })
        .catch((err) => { console.log(err); });
    }
  }, [getUserByID]);



  const isEmpty = !yearlyMoodOverview || (yearlyMoodOverview as any)?.length === 0;

  return (
    <div className="mood-card">

      {/* ── Header ─────────────────────────────────────────── */}
      <div className="mood-card__header">
        <div className="mood-card__header-left">
          <span className="mood-card__dot" />
          <h3 className="mood-card__title">Team Mood Overview</h3>
        </div>
    </div>

      {/* ── Chart area ─────────────────────────────────────── */}
      <div className="mood-card__body">
        {isEmpty ? (
          <div className="mood-card__empty">
            <img src="/img/User_empty.png" alt="" width={52} height={48} />
            <p>No mood data yet</p>
          </div>
        ) : (
          // overflow: visible ensures chart top isn't clipped
          <div className="mood-card__chart-wrap">
            <MoodLineChart chartData={yearlyMoodOverview} />
          </div>
        )}
      </div>
    </div>
  );
}